"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.recordOnboardingRequestSchema = exports.onboardingStateSchema = exports.ONBOARDING_EVENTS = exports.TOUR_VERSION = void 0;
const zod_1 = require("zod");
/**
 * ┌───────────────────────────────────────────────────────────────────────────┐
 * │ F-1 · whether a person has been welcomed, and what they did with the tour. │
 * └───────────────────────────────────────────────────────────────────────────┘
 *
 * Once per USER, not per workspace — `user_onboarding` (0201) is keyed on the person, like their
 * preferences. `GET /account/onboarding` reads it; `POST /account/onboarding` records one event.
 *
 * ⚠️⚠️ **THE TOUR'S ANSWERS ARE ABOUT ONE VERSION OF THE TOUR.** Raising `TOUR_VERSION` after a release
 * that changes what the product is offers the tour again to everybody who finished or skipped the
 * old one: the stamps were about a tour that no longer exists. The welcome is not versioned — it
 * says what Forecastify is, which a release does not change.
 */
exports.TOUR_VERSION = 1;
exports.ONBOARDING_EVENTS = ['welcome_seen', 'tour_finished', 'tour_skipped'];
exports.onboardingStateSchema = zod_1.z.object({
    /** The welcome cards have been seen, and closed by whatever means. */
    welcomeSeen: zod_1.z.boolean(),
    /** The CURRENT tour was walked to its end. */
    tourFinished: zod_1.z.boolean(),
    /** The CURRENT tour was declined, or left part way through. */
    tourSkipped: zod_1.z.boolean(),
});
exports.recordOnboardingRequestSchema = zod_1.z.object({
    event: zod_1.z.enum(exports.ONBOARDING_EVENTS),
});
//# sourceMappingURL=onboarding.js.map